import { useEffect } from 'react';

import { useGetOwnOrganizations } from '@/features/api/hooks/grapevine-organization/useGetOwnOrganizations';
import { useLastSenderStore } from '@/features/sender-selection/store/useLastSenderStore';
import type { Sender } from '@/features/sender-selection/types/sender';
import { SenderType } from '@/features/sender-selection/types/sender';

type ValidatedSenderSelection = {
  sender: Sender;
  setSender: (sender: Sender) => void;
};

export const useValidatedSenderSelection = (): ValidatedSenderSelection => {
  const sender = useLastSenderStore((state) => state.sender);
  const setSender = useLastSenderStore((state) => state.setSender);

  const { data: ownOrganizations, isSuccess: ownOrganizationsLoaded } =
    useGetOwnOrganizations();

  useEffect(() => {
    if (!ownOrganizationsLoaded) {
      return;
    }

    if (sender.type !== SenderType.ORGANIZATION) {
      return;
    }

    const stillMember = ownOrganizations?.some(
      (org) => org.id === sender.organizationId
    );
    if (!stillMember) {
      setSender({ type: SenderType.USER });
    }
  }, [sender, ownOrganizations, ownOrganizationsLoaded, setSender]);

  return { sender, setSender };
};
